import "../../assets/styles/cities.css";

function Map() {
  return (
    <div >
      <div className="map">
        <iframe
          className="google-maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6512742.904804467!2d-124.5938672237518!3d37.15150473373539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2stz!4v1740768040883!5m2!1sen!2stz"
        ></iframe>
      </div>
    </div>
  );
}

export default Map;
